import Exception from './exception';
import AdaptedCollection from '../../utils/backbone/adapted-collection';
import ExceptionTransformer from '../../utils/transformers/ExceptionTransformer';
const exceptionTransformer = ExceptionTransformer.transform;
export default AdaptedCollection.extend({
    model: Exception,
    adapt: exceptionTransformer,
});
